// API URL configuration
// In production, use REACT_APP_API_URL from environment variables
// In development, use localhost:4000
const PRODUCTION_API_URL = process.env.REACT_APP_API_URL || 'https://api.yourdomain.com';
const DEVELOPMENT_API_URL = process.env.REACT_APP_API_URL || 'http://localhost:4000';

// Auto-detect environment and use appropriate API URL
export const API_BASE_URL = process.env.NODE_ENV === 'production' 
  ? PRODUCTION_API_URL 
  : DEVELOPMENT_API_URL;

// Helper function to get full API URL
export const getApiUrl = (endpoint: string) => {
  return `${API_BASE_URL}${endpoint.startsWith('/') ? endpoint : `/${endpoint}`}`;
};

// Common API endpoints
export const API_ENDPOINTS = {
  // Auth
  LOGIN: '/api/auth/login',
  
  // Blogs
  BLOGS: '/api/blogs',
  BLOG_BY_SLUG: (slug: string) => `/api/blogs/slug/${slug}`,
  
  // Categories
  CATEGORIES: '/api/categories',
  
  // Portfolio
  PORTFOLIO: '/api/portfolio',
  PORTFOLIO_PUBLISHED: '/api/portfolio/published',
  PORTFOLIO_CATEGORIES: '/api/portfolio/categories',
  
  // Reviews
  REVIEWS_APPROVED: '/api/reviews/approved',
  REVIEWS_SUBMIT: '/api/reviews',
  
  // Comments
  COMMENTS_BY_BLOG: (blogId: string) => `/api/comments/blog/${blogId}`,
  COMMENTS_SUBMIT: '/api/comments',
  
  // Likes
  LIKES_COUNT: (blogId: string) => `/api/likes/blog/${blogId}/count`,
  LIKES_TOGGLE: (blogId: string) => `/api/likes/blog/${blogId}`,
  
  // Analytics
  ANALYTICS_STATS: '/api/analytics/stats',
  ANALYTICS_TOP_BLOGS: '/api/analytics/top-blogs',
  ANALYTICS_TRAFFIC: '/api/analytics/traffic-sources',
  ANALYTICS_DEVICES: '/api/analytics/devices',
  
  // Admin
  ADMIN_COMMENTS: '/api/comments/admin/all',
  ADMIN_REVIEWS: '/api/reviews/admin/all',
  ADMIN_PORTFOLIO: '/api/portfolio/admin/all'
};

export default API_BASE_URL;